import { render, staticRenderFns } from "./NewVideos.vue?vue&type=template&id=572c1ab9&scoped=true&"
import script from "./NewVideos.vue?vue&type=script&lang=js&"
export * from "./NewVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c1ab9",
  null
  
)

export default component.exports